import { CancelTokenSource } from 'axios';

import { Product } from '@rygen/rygen-ui/model';

import { ProductSearchPayload, ProductSearchResult } from '@/model';

import { BaseHttpController } from './BaseHttpController';

const endpoint = 'product';

export class ProductController extends BaseHttpController {
  constructor() {
    super(endpoint);
  }

  async findById(productId: number): Promise<Product> {
    const response = await this.http.get<Product>(`${productId}`);
    return new Product(response.data);
  }

  async save(product: Partial<Product>): Promise<Product> {
    const response = await this.http.post<Product>('', product);
    return new Product(response.data);
  }

  async update(product: Partial<Product>): Promise<Product> {
    const response = await this.http.put<Product>(`${product.id}`, product);
    return new Product(response.data);
  }

  async search(
    payload: ProductSearchPayload,
    cancelToken?: CancelTokenSource,
  ): Promise<ProductSearchResult> {
    const response = await this.http.post<ProductSearchResult>(
      'search',
      payload,
      { cancelToken: cancelToken?.token },
    );
    return new ProductSearchResult(response.data);
  }
}
